
import { Component, Vue } from 'vue-property-decorator'

/**
 * デバッグ画面
 */
@Component
export default class DebugHome extends Vue {
  /**
   * 画面の読み込み時処理
   */
  private async created(): Promise<void> {
    this.$loading.start()
    this.$logger.log('===== 初期処理実行')
    this.$loading.complete()
  }

  /**
   * 簡易テスト用
   */
  private async sandboxEvent(): Promise<void> {
    this.$loading.start()

    this.$logger.log('これは簡易テスト用のメソッドです。')
    this.$logger.log('中身を書き換えてテストに使用してください。')
    this.$logger.log('ただし、このファイルを修正してコミットしないでください。')
    await this.sleep(3000)

    this.$loading.complete()
  }

  /**
   * テスト用のウェイト処理
   *
   * @param ms ミリ秒
   */
  private async sleep(ms: number): Promise<void> {
    await new Promise((resolve) => setTimeout(resolve, ms))
  }
}
